import React from "react";
import styles from "../../ScholarshipApplication/ScholarshipApplicationDetails/ScholarshipApplicationDetails.module.scss";
import {
    Card, Box, Typography, Chip, Dialog, DialogTitle, DialogContent, DialogActions, Button,
} from "@mui/material";
import FormGenerator from "../../../components/FormBuilder/FormBuilder";
import useFundExpenseDetail from "./useFundExpenseDetail"
import { FundExpenseDetailForm } from "../../../types/formTypes"
import AddReceiptModel from "./AddReceiptModel"
import ReasonModel from "./ReasonModel";

const FundExpenseDetail = () => {
    const { fundDetail,type,data,purposeLoading,userData,purposeError,ViewReceiptColumn, fundsFormFields, buttonList, open,submitType,isLoading, isError, setOpen, columns, handleRejectRecipet,handleApproveRecipet, handleDownload, id, handleUploadReceipt, file, showReason,setShowRason } = useFundExpenseDetail()
    return (<Card
        style={{
            padding: "2rem",
            border: 0,
            boxShadow: "none",
            background: "none",

        }}
    >
        <Box className={"cardBoxUI"}>
            <AddReceiptModel setOpen={setOpen} data={data} ViewReceiptColumn={ViewReceiptColumn} open={open} file={file} type={type} columns={columns} handleUploadReceipt={handleUploadReceipt} id={id} />
            <ReasonModel showReason={showReason} setShowRason={setShowRason} handleApproveRecipet={submitType == 'approve' ? handleApproveRecipet : handleRejectRecipet}/>
            <Box className={styles.header}>
                <Typography variant="h5" className={styles.title}>
                    Expense Details
                </Typography>
                <Box className={styles.navigationButtons}>
                    <Typography variant="h6">
                        Student Name
                    </Typography>
                  {<Chip label={fundDetail?.name || userData?.full_name} color="info" sx={{ fontSize: 16 }} />}
                    <Typography variant="h6">
                        Scholarship ID
                    </Typography>
                   {<Chip label={fundDetail?.scholarship_id || userData?.scholarship_name} color="success" sx={{ fontSize: 16 }} />}
                </Box>
            </Box>
           {!isLoading && !isError  && <FormGenerator<FundExpenseDetailForm> fields={fundsFormFields} onSubmit={() => null} direction="column" ButtonList={buttonList} />}
        </Box>
    </Card>)
}

export default FundExpenseDetail